{
  "blocks": [
    {
      "id": "test-pgt-a-products-orchid",
      "kind": "test",
      "tags": [
        "testing",
        "genetic-screening",
        "ivf",
        "during-cycle",
        "genomic"
      ],
      "title": "Orchid",
      "subtitle": "Whole-genome embryo screening that includes PGT-A",
      "icon": "🧬",
      "body": {
        "testName": "Orchid whole-genome embryo screening",
        "category": "genetic",
        "evidenceStrength": "emerging",
        "isCommercialProductProfile": true,
        "commercialProductProfile": {
          "categoryTestId": "test-pgt-a",
          "company": "Orchid",
          "productUrl": "https://www.orchidhealth.com/",
          "marketedNames": [
            "Orchid Embryo Report",
            "Orchid whole-genome embryo screening"
          ],
          "availability": [
            {
              "region": "Patient access",
              "detail": "Usually arranged through a fertility clinic as part of an embryo biopsy workflow. Ask which PGT-A and broader genomic layers are included in the quoted report."
            }
          ]
        },
        "whatItMeasures": "Orchid's whole-genome embryo screening includes chromosome copy-number screening (PGT-A) and may return additional genomic information from the same embryo biopsy sample.",
        "howItWorks": "Embryos are created through IVF and biopsied at the blastocyst stage. The biopsy sample is sent through Orchid's whole-genome workflow while the embryo is typically frozen. The report can include PGT-A-style chromosome findings alongside other genomic layers, depending on the ordered service.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Embryo biopsy cells"
          },
          {
            "kind": "prep",
            "value": "Requires IVF and blastocyst biopsy"
          },
          {
            "kind": "results",
            "value": "Ask the clinic for current timing"
          }
        ],
        "expectations": {
          "canExpect": [
            "PGT-A-style chromosome findings for biopsied embryos",
            "A broader report may include additional genomic layers from the same biopsy",
            "A clinic and genetics professional to explain which layers were ordered"
          ],
          "shouldNotExpect": [
            "Every Orchid report to include the same optional layers",
            "A guarantee of implantation, pregnancy, or live birth",
            "A replacement for genetic counseling or the clinic's transfer plan"
          ]
        },
        "considerations": [
          "Ask whether PGT-A is included in the quoted Orchid report or billed separately.",
          "Ask which additional genomic layers are available for your embryos and location.",
          "Ask how mosaic, no-result, and other complex findings will be reviewed before transfer decisions."
        ],
        "bestFor": [
          "People already planning embryo biopsy who want to compare a broader genomic workflow with standard PGT-A",
          "People who want a single report to clarify which embryo-genetic layers were ordered"
        ],
        "headlineStat": "PGT-A plus broader screening",
        "atHome": false,
        "clinicRequired": true,
        "dataPoints": [],
        "section": "genetic-screening"
      },
      "sources": [
        {
          "title": "What's in an Orchid embryo report?",
          "journal": "Orchid",
          "url": "https://www.orchidhealth.com/guides/whats-in-an-orchid-embryo-report",
          "evidenceLevel": "official"
        }
      ],
      "readTimeMinutes": 3
    },
    {
      "id": "test-pgt-a-products-herasight",
      "kind": "test",
      "tags": [
        "testing",
        "genetic-screening",
        "ivf",
        "during-cycle",
        "genomic"
      ],
      "title": "Herasight",
      "subtitle": "Broader embryo analysis built from PGT-A data",
      "icon": "🧬",
      "body": {
        "testName": "Herasight embryo genomic analysis",
        "category": "genetic",
        "evidenceStrength": "emerging",
        "isCommercialProductProfile": true,
        "commercialProductProfile": {
          "categoryTestId": "test-pgt-a",
          "company": "Herasight",
          "productUrl": "https://www.herasight.com/",
          "marketedNames": ["Herasight", "ImputePGTA"],
          "availability": [
            {
              "region": "Patient access",
              "detail": "May use existing PGT-A data together with parental sequencing. Confirm with Herasight and your fertility clinic whether your prior or planned PGT-A workflow is compatible."
            }
          ]
        },
        "whatItMeasures": "Herasight can use PGT-A data together with parental sequencing to reconstruct broader embryo-genomic information. This extends the information available from a PGT-A workflow rather than representing a different PGT subtype.",
        "howItWorks": "A fertility clinic or genetics partner performs the embryo biopsy and PGT-A workflow. Herasight may then analyze the resulting data with parental sequencing to generate additional embryo-genomic information. Confirm the exact report, data requirements, and availability before ordering.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "PGT-A data plus parental DNA"
          },
          {
            "kind": "prep",
            "value": "Requires an IVF embryo-testing workflow"
          },
          {
            "kind": "results",
            "value": "Ask for current timing"
          }
        ],
        "expectations": {
          "canExpect": [
            "A commercial pathway that may add broader analysis to existing PGT-A data",
            "A report whose included layers depend on the data available and the service ordered",
            "A need to confirm compatibility with your clinic and prior testing laboratory"
          ],
          "shouldNotExpect": [
            "Herasight to replace the embryo biopsy or every clinic's PGT-A workflow",
            "A diagnosis or certainty about a future child's health",
            "The same report or availability in every country"
          ]
        },
        "considerations": [
          "Ask whether your planned or existing PGT-A data can be used and what file or laboratory requirements apply.",
          "Ask which outputs are included and whether parental sequencing is required.",
          "Ask how the additional information should or should not affect embryo-transfer decisions."
        ],
        "bestFor": [
          "People who are already pursuing PGT-A and want to understand whether broader analysis can use the same data",
          "People comparing commercial embryo-genomics pathways before biopsy or re-analysis"
        ],
        "headlineStat": "PGT-A data plus added analysis",
        "atHome": false,
        "clinicRequired": true,
        "dataPoints": [],
        "section": "genetic-screening"
      },
      "sources": [
        {
          "title": "Should I do embryo screening?",
          "journal": "Herasight",
          "url": "https://www.herasight.com/blog/should-i-do-embryo-screening",
          "evidenceLevel": "official"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [
    {
      "from": "test-pgt-a",
      "to": "test-pgt-a-products-orchid",
      "type": "related-to",
      "label": "Sold as"
    },
    {
      "from": "test-pgt-a",
      "to": "test-pgt-a-products-herasight",
      "type": "related-to",
      "label": "Sold as"
    }
  ],
  "localeVariants": []
}
